import MembersList from './MembersList';
import BreadcrumbWrapper from '../BreadcrumbWrapper';
import { useAuth } from '../../contexts/auth';
import service from '@Service';
import { useState } from 'react';
import {
  toastSuccess,
  toastError,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/toast';

const Members = () => {
  const { hasRole } = useAuth();
  const [running, setRunning] = useState(false);

  const handleRunActivitySummary = async () => {
    if (running) return;
    setRunning(true);
    try {
      await service.runSummarizeActivity({});
      toastSuccess('Activity summary job started');
    } catch (err) {
      console.error(err);
      toastError('Failed to start activity summary job');
    } finally {
      setRunning(false);
    }
  };

  const isAdmin = hasRole(['ADMIN_ROLE']);

  return (
    <div>
      <div className="flex">
        <BreadcrumbWrapper
          crumbArray={[{ path: '/members', label: 'Members' }]}
        />
      </div>

      <div className="flex items-center justify-between pt-4">
        <h1 className="text-2xl font-bold">Members</h1>
        {isAdmin && (
          <button
            type="button"
            onClick={handleRunActivitySummary}
            disabled={running}
            className="rounded-md bg-black px-4 py-2 text-sm font-medium text-white hover:bg-gray-800 disabled:opacity-50"
          >
            {running ? 'Starting...' : 'Run Activity Summary'}
          </button>
        )}
      </div>

      <MembersList />
    </div>
  );
};

export default Members;
